import {createGlobalStyle} from 'styled-components';

export const Styles = createGlobalStyle`

    :root {
        /* Colors */
        --primary: #5271ff;
        --primary-dark: #3B54DB;
        --primary-light: #8BA0FF;
        --primary-bg: #EEF1FF;
        --accent: #FFDE59;
        --text-primary: #1A1A2E;
        --text-secondary: #4A4A68;
        --text-muted: #8888A0;
        --bg-primary: #FFFFFF;
        --bg-secondary: #F8F9FC;
        --bg-dark: #0F0F23;
        --border: #E2E4F0;

        /* Shadows */
        --shadow-sm: 0 2px 8px rgba(82, 113, 255, 0.08);
        --shadow-md: 0 4px 20px rgba(82, 113, 255, 0.12);
        --shadow-lg: 0 8px 40px rgba(82, 113, 255, 0.16);
        --shadow-xl: 0 16px 60px rgba(82, 113, 255, 0.2);

        /* Border Radius */
        --radius-sm: 8px;
        --radius-md: 12px;
        --radius-lg: 16px;
        --radius-xl: 24px;

        /* Spacing */
        --section-padding: 6rem 0;
        --section-padding-mobile: 3rem 0;
    }

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: var(--bg-primary);
        overflow-x: hidden;
        color: var(--text-secondary);
    }

    a:hover {
        color: var(--primary);
    }

    input,
    textarea {
        border-radius: var(--radius-sm);
        border: 1px solid var(--border);
        background: var(--bg-secondary);
        transition: all 0.3s ease-in-out;
        outline: none;
        width: 100%;
        padding: 1rem 1.25rem;
        font-size: 1rem;
        color: var(--text-primary);

        :focus-within {
            background: var(--bg-primary);
            border-color: var(--primary);
            box-shadow: 0 0 0 3px rgba(82, 113, 255, 0.1);
        }
    }

    h1 {
        font-family: 'Motiva Sans Bold', serif;
        color: var(--text-primary);
        font-size: 64px;
        line-height: 1.1;
        font-weight: 600;

        @media only screen and (max-width: 890px) {
            font-size: 48px;
        }

        @media only screen and (max-width: 414px) {
            font-size: 36px;
        }
    }

    h2 {
        font-family: 'Motiva Sans Bold', serif;
        color: var(--text-primary);
        font-size: 48px;
        line-height: 1.15;

        @media only screen and (max-width: 890px) {
            font-size: 36px;
        }

        @media only screen and (max-width: 414px) {
            font-size: 28px;
        }
    }

    h3 {
        font-family: 'Motiva Sans Bold', serif;
        color: var(--text-primary);
        font-size: 42px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
            font-size: 32px;
        }

        @media only screen and (max-width: 414px) {
            font-size: 26px;
        }
    }

    h4 {
        font-family: 'Motiva Sans Bold', serif;
        color: var(--text-primary);
        font-size: 28px;
        line-height: 1.25;

        @media only screen and (max-width: 890px) {
            font-size: 24px;
        }

        @media only screen and (max-width: 414px) {
            font-size: 22px;
        }
    }

    h5 {
        font-family: 'Motiva Sans Bold', serif;
        color: var(--text-primary);
        font-size: 22px;
        line-height: 1.3;
    }

    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: var(--text-primary);
        font-size: 20px;
        line-height: 1.35;
    }

    p {
        color: var(--text-secondary);
        font-size: 18px;
        line-height: 1.6;
    }

    a {
        text-decoration: none;
        outline: none;
        color: var(--primary);

        :hover {
            color: var(--primary-dark);
        }
    }

    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
